import { css } from "@emotion/react"

const ArticleImage = props => (
  <img
    {...props}
    css={css`
      width: auto;
      max-width: 100%;
      max-height: 525px; /* 700 x 524 is 4:3 ratio */
      object-fit: contain;
      display: block;
      margin: auto;
    `}
  />
)

export default ArticleImage
